module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-staying-on-track@2x.569bf84a.png";